import Bluebird from 'bluebird';
import { findAny } from '../../../../../services/arrays';
import { ajaxDone } from '../../../services/ajax';
import InputField from '../../../services/input-fields/input-field';
import { removeError, removeGlobalError, updateErrorView } from '../errors/errors';
import DateTimeField from '../input-fields/datetime-field';
import Unibar from '../input-fields/unibar';
import { IWidgetFormRow } from '../models/form';
import { BookingMode } from '../storage';
import { validateFlight } from './flight-validator';

export function validateField(field: InputField, lightMode?: boolean): Bluebird<boolean> {
    let isValid = true;

    if (field.isEmpty()) {
        isValid = false;
        removeError(field);
    }

    const promises: Array<Bluebird<any>> = [];

    if (isValid) {
        if (field instanceof DateTimeField) {
            promises.push(validateDTField(field).then(x => isValid = x));
        } else if (field instanceof Unibar) {
            promises.push(validateUnibar(field).then(x => isValid = x));
        }
    }

    if (isValid) removeError(field);
    if (!field.isEmpty()) removeGlobalError();

    promises.push(updateErrorView());

    return Bluebird.all(promises)
        .then(() => updateErrorView())
        .then(() => {
            const $field = field.$JQueryAll;
            $field.removeClass('isGoed').removeClass('isFout');

            if (lightMode && isValid || !lightMode) {
                $field.addClass(isValid ? 'isGoed' : 'isFout');
            }

            return isValid;
        });
}

async function validateUnibar(field: Unibar): Bluebird<boolean> {
    await field.done;
    return !!field.selectedResult;
}

async function validateDTField(field: DateTimeField): Bluebird<boolean> {
    const hours = parseInt(field.hours.value, 10),
        minutes = parseInt(field.minutes.value, 10);

    return !field.isEmpty() && hours >= 0 && minutes >= 0;
}

export async function validateRow(
    row: IWidgetFormRow,
    bookingMode: BookingMode,
    noFlight: boolean,
    isReturn: boolean
): Bluebird<boolean> {
    await ajaxDone();

    if (noFlight) {
        return combineValidations([
            validateField(row.noflight.from),
            validateField(row.noflight.to),
            validateField(row.noflight.datetime)
        ]);
    }

    const validations = [
        validateFlight(row.flight.flightNumber, row.flight.flightDate, true)
    ];

    if (!isReturn && bookingMode === BookingMode.ToAirport
        || isReturn && bookingMode === BookingMode.FromAirport
        || bookingMode === BookingMode.DoorToDoor) {
        validations.push(validateField(row.fromAddress));
    }

    if (!isReturn && bookingMode === BookingMode.FromAirport
        || isReturn && bookingMode === BookingMode.ToAirport
        || bookingMode === BookingMode.DoorToDoor) {
        validations.push(validateField(row.toAddress));
    }

    return combineValidations(validations);
}

export function validateNoFlight(from: Unibar, to: Unibar, datetime: DateTimeField): Bluebird<boolean> {
    return combineValidations([
        validateField(from),
        validateField(to),
        validateField(datetime)]);
}

function combineValidations(promises: Array<Bluebird<boolean>>): Bluebird<boolean> {
    return Bluebird.all(promises)
        .then(results => !findAny(results, valid => !valid));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/validation/validator.ts